import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/gold-logo-transparent.png'


const _hoisted_1 = { class: "flex flex-col p-5" }
const _hoisted_2 = { class: "h-screen" }
const _hoisted_3 = { class: "flex-1 flex items-center justify-center mb-5" }
const _hoisted_4 = { class: "block max-w-xs p-6 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700" }
const _hoisted_5 = { class: "mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white" }
const _hoisted_6 = {
  key: 0,
  class: "mb-4 text-sm text-green-600"
}
const _hoisted_7 = { class: "w-full flex flex-row flex-wrap justify-between gap-1" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "p-2" }
const _hoisted_14 = { class: "text-sm" }
const _hoisted_15 = { class: "font-semibold text-lg" }
const _hoisted_16 = { class: "font-normal mb-2" }
const _hoisted_17 = { class: "text-gray-400" }

import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { generateCsv } from '@/helpers';
import ServiceService from '@/service/service.service';
import ServiceModal from '@/components/admin-dashboard/ServiceModal.vue';
import LoadingModal from '@/components/admin-dashboard/LoadingModal.vue';
import ConfirmationModal from '@/components/admin-dashboard/ConfirmationModal.vue';
import EditServiceModal, {
  Service,
} from '@/components/admin-dashboard/EditServiceModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ServicesView',
  setup(__props) {

const router = useRouter();

const services = ref<[any]>();

const showModal = ref(false);

const isLoading = ref(false);

const showConfirmation = ref(false);

const serviceForDeletion = ref(null);

const editingService = ref<Service | null>(null);

const copiedConfig = ref<any>(null);

function openEditModal(service: Service) {
  editingService.value = service;
}

onMounted(async () => {
  if (!localStorage.getItem('loggedIn')) {
    router.push({ name: 'admin-login' });
    return;
  }
  try {
    services.value = await ServiceService.getAll();
  } catch (error) {
    console.error(error);
  }
});

function deleteService(service: any) {
  if (isLoading.value) return;
  serviceForDeletion.value = service;
  showConfirmation.value = true;
}

async function confirmDeletion() {
  showConfirmation.value = false;
  isLoading.value = true;
  console.log(serviceForDeletion.value);
  await ServiceService.delete(serviceForDeletion.value);
  services.value = await ServiceService.getAll();
  isLoading.value = false;
  alert('Service and its associated images deleted successfully.');
}

function copyConfig(service: any) {
  copiedConfig.value = service.config;
  alert(`Configuration from "${service.title}" copied successfully.`);
}

function pasteConfigTo(service: any) {
  if (!copiedConfig.value) {
    alert('No configuration copied yet.');
    return;
  }

  editingService.value = {
    ...service,
    config: JSON.parse(JSON.stringify(copiedConfig.value)), // Deep clone
  };
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[5] || (_cache[5] = _createElementVNode("img", {
            src: _imports_0,
            alt: "TALAB - Ultimate Student App in London Logo",
            class: "w-32 mx-auto"
          }, null, -1)),
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = true)),
            className: "px-3 py-3 text-indigo-600 bg-indigo-50 rounded-lg duration-150 hover:bg-indigo-100 active:bg-indigo-200 flex items-center cursor-pointer"
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("p", { className: "mr-1" }, "Add Service", -1),
            _createElementVNode("svg", {
              class: "w-6 h-6",
              "aria-hidden": "true",
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M5 12h14m-7 7V5"
              })
            ], -1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(services.value?.length ?? "Loading..."), 1),
          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "font-normal text-gray-700 dark:text-gray-400" }, "Services", -1))
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "text-center text-3xl font-medium my-5" }, "Current Services", -1)),
        (copiedConfig.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, " ✅ Copied configuration is ready to paste. "))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(services.value, (service) => {
            return (_openBlock(), _createElementBlock("div", {
              key: service.id,
              onClick: ($event: any) => (openEditModal(service)),
              class: "w-[33%] border-2 rounded-lg overflow-hidden relative cursor-pointer"
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "text-white bg-red-600 hover:bg-red-800 focus:ring-1 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm p-2 text-center inline-flex items-center me-2 absolute right-2 top-2",
                onClick: ($event: any) => (deleteService(service))
              }, _cache[7] || (_cache[7] = [
                _createElementVNode("svg", {
                  class: "w-[16px] h-[16px] text-gray-800 dark:text-white",
                  "aria-hidden": "true",
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "24",
                  fill: "none",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "1.3",
                    d: "M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"
                  })
                ], -1)
              ]), 8, _hoisted_9),
              _createElementVNode("button", {
                class: "bg-yellow-400 hover:bg-yellow-500 text-sm text-white px-2 py-1 rounded",
                onClick: _withModifiers(($event: any) => (copyConfig(service)), ["stop"])
              }, " Copy Config ", 8, _hoisted_10),
              _createElementVNode("button", {
                class: "bg-green-500 hover:bg-green-600 text-sm text-white px-2 py-1 rounded",
                onClick: _withModifiers(($event: any) => (pasteConfigTo(service)), ["stop"])
              }, " Paste Config ", 8, _hoisted_11),
              _createElementVNode("img", {
                src: service.coverImg,
                alt: "Cover Image",
                class: "object-cover h-2/6 w-full"
              }, null, 8, _hoisted_12),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("p", _hoisted_14, _toDisplayString(service.category), 1),
                _createElementVNode("p", _hoisted_15, _toDisplayString(service.title), 1),
                _createElementVNode("p", _hoisted_16, _toDisplayString(service.subTitle), 1),
                _createElementVNode("p", _hoisted_17, _toDisplayString(service.description), 1)
              ])
            ], 8, _hoisted_8))
          }), 128))
        ])
      ])
    ]),
    (showModal.value)
      ? (_openBlock(), _createBlock(ServiceModal, {
          key: 0,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (showModal.value = false))
        }))
      : _createCommentVNode("", true),
    (isLoading.value)
      ? (_openBlock(), _createBlock(LoadingModal, { key: 1 }))
      : _createCommentVNode("", true),
    (showConfirmation.value)
      ? (_openBlock(), _createBlock(ConfirmationModal, {
          key: 2,
          onCancel: _cache[2] || (_cache[2] = ($event: any) => (showConfirmation.value = false)),
          onConfirm: confirmDeletion
        }))
      : _createCommentVNode("", true),
    (editingService.value)
      ? (_openBlock(), _createBlock(EditServiceModal, {
          key: 3,
          service: editingService.value,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (editingService.value = null))
        }, null, 8, ["service"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})